import React from 'react'
import PropTypes from 'prop-types'

const StatusFilter = props => (
  <select
    className="filter-header"
    onChange={props.onChangeStatus}
  >
    <option value="">STATUS</option>
    {props.statusList.map((status, index) => (
      <option key={status} value={index}>{status}</option>
    ))}
  </select>
)

StatusFilter.propTypes = {
  onChangeStatus: PropTypes.func.isRequired,
  statusList: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default StatusFilter
